// extracted by mini-css-extract-plugin
module.exports = {"hidden":"MarketingMaterialsForm__hidden___yh22P"};